import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function MobileHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const menuItems = [
    { path: '/dashboard', icon: 'ri-dashboard-line', label: 'Dashboard' },
    { path: '/gerar-apostas', icon: 'ri-magic-line', label: 'Gerar Apostas' },
    { path: '/meus-jogos', icon: 'ri-ticket-line', label: 'Meus Jogos' },
    { path: '/resultados', icon: 'ri-bar-chart-line', label: 'Resultados' },
    { path: '/estatisticas', icon: 'ri-bar-chart-2-line', label: 'Estatísticas' },
    { path: '/notificacoes', icon: 'ri-notification-3-line', label: 'Notificações' }
  ];
  useEffect(() => {
    try {
      if (open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    } catch {}
    return () => { try { document.body.style.overflow = ''; } catch {} };
  }, [open]);
  return (
    <div className="md:hidden sticky top-0 z-40 bg-slate-950/90 backdrop-blur border-b border-white/10">
      <div className="flex items-center justify-between px-4 py-3">
        <Link to="/dashboard" className="flex items-center gap-2">
          <img src="/logo-clover.png" alt="Premiei" className="h-7 w-7" />
          <span className="font-bold">Premiei</span>
        </Link>
        <button onClick={() => setOpen(true)} className="px-3 py-2 rounded-lg bg-white/5 border border-white/10">
          <i className="ri-menu-line"></i>
        </button>
      </div>
      {open && createPortal(
        <div className="fixed inset-0 z-[9999] bg-slate-950 opacity-100 flex">
          <div className="w-80 h-full bg-gradient-to-b from-slate-900 to-slate-950 text-white border-r border-white/10 p-4 shadow-2xl overflow-auto">
            <div className="flex items-center gap-2 mb-6">
              <img src="/logo-clover.png" alt="Premiei" className="h-8 w-8" />
              <span className="text-xl font-bold">Premiei</span>
              <button onClick={() => setOpen(false)} className="ml-auto px-2 py-1 bg-white/5 border border-white/10 rounded">Fechar</button>
            </div>
            <nav className="space-y-2">
              {menuItems.map((item)=>{
                const isActive = location.pathname === item.path;
                return (
                  <button
                    key={item.path}
                    onClick={() => { navigate(item.path); setOpen(false); }}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left ${isActive ? 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/30' : 'bg-white/5 border border-white/10'}`}
                  >
                    <i className={`${item.icon} text-lg`}></i>
                    <span className="font-medium text-sm">{item.label}</span>
                  </button>
                );
              })}
            </nav>
            <div className="mt-6 pt-4 border-t border-white/10">
              <button
                onClick={() => { logout(); setOpen(false); navigate('/'); }}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-gradient-to-r from-rose-600 to-pink-600 hover:from-rose-500 hover:to-pink-500"
              >
                <i className="ri-logout-box-line text-lg"></i>
                <span className="font-semibold">Sair</span>
              </button>
            </div>
          </div>
          <div className="flex-1 h-full" onClick={() => setOpen(false)}></div>
        </div>,
        document.body
      )}
    </div>
  );
}
